import { useState, useEffect } from "react";
import axios from "axios";
import { resolveImageUrl } from "@/lib/api";

// <img> tags can't send the Authorization header, and auth cookies are unreliable on
// some phones (iPhone). Fetch protected /api/images via axios (header auth + auto-refresh)
// and render a blob URL instead.
const blobCache = new Map();

export function useAuthedImage(url) {
  const resolved = resolveImageUrl(url);
  const needsAuth = typeof url === "string" && url.startsWith("/api/images/");
  const [src, setSrc] = useState(() => (needsAuth ? blobCache.get(url) || null : resolved));
  useEffect(() => {
    if (!url) { setSrc(null); return; }
    if (!needsAuth) { setSrc(resolved); return; }
    if (blobCache.has(url)) { setSrc(blobCache.get(url)); return; }
    let alive = true;
    axios.get(resolved, { responseType: "blob", timeout: 30000 })
      .then(({ data }) => {
        const obj = URL.createObjectURL(data);
        blobCache.set(url, obj);
        if (alive) setSrc(obj);
      })
      .catch(() => { if (alive) setSrc(resolved); });
    return () => { alive = false; };
  }, [url, needsAuth, resolved]);
  return src;
}

export function AuthImg({ src, alt = "", ...props }) {
  const s = useAuthedImage(src);
  return <img src={s || undefined} alt={alt} {...props} />;
}
